import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import PublicLayout from './layouts/PublicLayout'; // Add this import
import ProtectedLayout from './layouts/ProtectedLayout'; // New: protected layout for auth-gated pages

import HomePage from './pages/public/HomePage';
import LoginPage from './pages/public/LoginPage';
import HowItWorksPage from './pages/public/HowItWorksPage';
import ServicesPage from './pages/public/ServicesPage';
import PricingPage from './pages/public/PricingPage';
import NotAuthorizedPage from './pages/public/NotAuthorizedPage';
import MeasurementsDemoPage from './pages/public/MeasurementsDemoPage';
import OfflinePage from './pages/public/OfflinePage';

import CustomerDashboardPage from './pages/customer/CustomerDashboardPage';
import CustomerOrdersPage from './pages/customer/CustomerOrdersPage';
import NewOrderPage from './pages/customer/NewOrderPage';
import OrderDetailPage from './pages/customer/OrderDetailPage';
import CustomerQuotePage from './pages/customer/CustomerQuotePage';
import InvoicePage from './pages/customer/InvoicePage';
import CheckoutPage from './pages/customer/CheckoutPage';
import CustomerAppointmentsPage from './pages/customer/CustomerAppointmentsPage';
import AppointmentDetailPage from './pages/customer/AppointmentDetailPage';
import CustomerMeasurementsPage from './pages/customer/CustomerMeasurementsPage';
import BookMeasurementPage from './pages/customer/BookMeasurementPage';
import ReviewMeasurementPage from './pages/customer/ReviewMeasurementPage';

import StaffDashboardPage from './pages/staff/StaffDashboardPage';
import ShipmentsPage from './pages/staff/ShipmentsPage';
import ShipmentDetailPage from './pages/staff/ShipmentDetailPage';
import MeasurementAppointmentsPage from './pages/staff/MeasurementAppointmentsPage';
import MeasurementSessionPage from './pages/staff/MeasurementSessionPage';

import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AnalyticsPage from './pages/admin/AnalyticsPage';
import AreasPage from './pages/admin/AreasPage';
import SlotsPage from './pages/admin/SlotsPage';
import RoutesPage from './pages/admin/RoutesPage';
import RouteDetailPage from './pages/admin/RouteDetailPage';
import DisputesPage from './pages/admin/DisputesPage';
import DisputeDetailPage from './pages/admin/DisputeDetailPage';

import WorkshopDashboardPage from './pages/workshop/WorkshopDashboardPage';
import IntakePage from './pages/workshop/IntakePage';
import QuotesPage from './pages/workshop/QuotesPage';
import ProductionPage from './pages/workshop/ProductionPage';
import DispatchPage from './pages/workshop/DispatchPage';
import WorkshopOrderDetailPage from './pages/workshop/WorkshopOrderDetailPage';

function App() {
  return (
    <AuthProvider>
      <Toaster />
      <Routes>
        {/* Public routes wrapped with PublicLayout */}
        <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
        <Route path="/how-it-works" element={<PublicLayout><HowItWorksPage /></PublicLayout>} />
        <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
        <Route path="/pricing" element={<PublicLayout><PricingPage /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><LoginPage /></PublicLayout>} />
        <Route path="/measurements-demo" element={<PublicLayout><MeasurementsDemoPage /></PublicLayout>} />
        <Route path="/not-authorized" element={<PublicLayout><NotAuthorizedPage /></PublicLayout>} />
        <Route path="/offline" element={<PublicLayout><OfflinePage /></PublicLayout>} />

        {/* Customer routes (already have AppShell layout) */}
        <Route path="/customer/dashboard" element={<CustomerDashboardPage />} />
        <Route path="/customer/orders" element={<CustomerOrdersPage />} />
        <Route path="/customer/orders/new" element={<NewOrderPage />} />
        <Route path="/customer/orders/:id" element={<OrderDetailPage />} />
        <Route path="/customer/quotes/:id" element={<CustomerQuotePage />} />
        <Route path="/customer/orders/:id/invoice" element={<InvoicePage />} />
        <Route path="/customer/checkout" element={<CheckoutPage />} />

        {/* Auth-gated customer pages (show only when logged in, with header) */}
        <Route
          path="/customer/appointments"
          element={
            <ProtectedLayout>
              <CustomerAppointmentsPage />
            </ProtectedLayout>
          }
        />
        <Route path="/customer/appointments/:id" element={<AppointmentDetailPage />} />
        <Route path="/customer/measurements" element={<CustomerMeasurementsPage />} />
        <Route
          path="/customer/measurements/book"
          element={
            <ProtectedLayout>
              <BookMeasurementPage />
            </ProtectedLayout>
          }
        />
        <Route path="/customer/measurements/review/:id" element={<ReviewMeasurementPage />} />

        {/* Staff routes (already have AppShell layout) */}
        <Route path="/staff/dashboard" element={<StaffDashboardPage />} />
        <Route path="/staff/shipments" element={<ShipmentsPage />} />
        <Route path="/staff/shipments/:id" element={<ShipmentDetailPage />} />
        <Route path="/staff/measurements" element={<MeasurementAppointmentsPage />} />
        <Route path="/staff/measurements/:id" element={<MeasurementSessionPage />} />

        {/* Admin routes (already have AppShell layout) */}
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/analytics" element={<AnalyticsPage />} />
        <Route path="/admin/areas" element={<AreasPage />} />
        <Route path="/admin/slots" element={<SlotsPage />} />
        <Route path="/admin/routes" element={<RoutesPage />} />
        <Route path="/admin/routes/:id" element={<RouteDetailPage />} />
        <Route path="/admin/disputes" element={<DisputesPage />} />
        <Route path="/admin/disputes/:id" element={<DisputeDetailPage />} />

        {/* Workshop routes (already have AppShell layout) */}
        <Route path="/workshop/dashboard" element={<WorkshopDashboardPage />} />
        <Route path="/workshop/intake" element={<IntakePage />} />
        <Route path="/workshop/quotes" element={<QuotesPage />} />
        <Route path="/workshop/production" element={<ProductionPage />} />
        <Route path="/workshop/dispatch" element={<DispatchPage />} />
        <Route path="/workshop/orders/:id" element={<WorkshopOrderDetailPage />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;